import {FiDownload} from "react-icons/fi";
import {LuFileChartPie} from "react-icons/lu";

import {Button} from "@/components/button/Button.tsx";
import {Icon} from "@/components/icon/Icon.tsx";
import {ANALYZER_REPORT_TITLE} from "@/pages/analyzer/Analyzer.constants.ts";
import {AnalyzerReportHeadingProps} from "@/pages/analyzer/Analyzer.types.ts";
import {useAnalyzerReportPdfDownload} from "@/pages/analyzer/hooks/useAnalyzerReportPdfDownload.ts";

import styles from "./AnalyzerReportHeading.module.scss";

export const AnalyzerReportHeading = ({report}: AnalyzerReportHeadingProps) => {
  const {downloadPdf, loading} = useAnalyzerReportPdfDownload();

  return (
    <div className={styles.heading}>
      <div className={styles.titles}>
        <div className={styles.titleRow}>
          <Icon icon={LuFileChartPie} size="core" removeDivDimensions />
          <div className={styles.title} role="heading" aria-level={2}>
            {ANALYZER_REPORT_TITLE}
          </div>
        </div>
        <div className={styles.subtitle}>{report.domain}</div>
      </div>
      <Button variant="secondary" size="small" onClick={() => downloadPdf(report)} disabled={loading}>
        <Icon icon={FiDownload} />
        Download PDF
      </Button>
    </div>
  );
};
